import { Suspense } from "react"
import { FeaturedProductsSection } from "@/components/e-commerce/home/featured-products"
import { FeaturedProductsSkeleton } from "@/components/e-commerce/home/featured-products/skeleton"
import { HeroSection } from "@/components/e-commerce/home/hero"
import { getPageBySlug } from "@/services/triibo-service"

export default async function Page() {
  const { page_data } = await getPageBySlug({ slug: "pagina-principal" })

  const fields = page_data?.acf_fields

  return (
    <div>
      {fields.pageSections.map((section) => {
        const sectionKey = `${section.acf_fc_layout}-${section.acf_fc_layout ?? Math.random()}`

        switch (section.acf_fc_layout) {
          case "heroBanner":
            return <HeroSection data={section} key={sectionKey} />

          case "featuredProducts":
            return (
              <Suspense
                fallback={<FeaturedProductsSkeleton />}
                key={sectionKey}
              >
                <FeaturedProductsSection data={section} />
              </Suspense>
            )

          default:
            return null
        }
      })}
    </div>
  )
}
